var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5918 1.71245L2.38095 6.25004H7.25013C7.66434 6.25004 8.00013 6.58582 8.00013 7.00004C8.00013 7.41425 7.66434 7.75004 7.25013 7.75004H2.38095L1.5918 12.2876L13.9295 7.00004L1.5918 1.71245ZM0.988869 7.00004L0.0637969 1.68087C-0.0109877 1.25086 0.128154 0.811352 0.436783 0.502722C0.824568 0.114942 1.40938 0.00231168 1.91345 0.218342L15.3158 5.9622C15.7309 6.14013 16.0001 6.54835 16.0001 7.00004C16.0001 7.45172 15.7309 7.85995 15.3158 8.03788L1.91345 13.7817C1.40938 13.9978 0.824568 13.8851 0.436783 13.4974C0.128154 13.1887 -0.0109879 12.7492 0.0637969 12.3192L0.988869 7.00004Z",
    fill: "#A0A9A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatArrow);
export default __webpack_public_path__ + "static/media/chat-arrow.e50739fb3669718489bec3a7b142a199.svg";
export { ForwardRef as ReactComponent };